import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, Injector } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../../../../../../visa';
import { pageFiltering, pageSorting } from '../../../../../../../listing.utils';
import { AppLoginPrincipalService, Pagination, PermissionTemplateService } from 'blg-akaun-ts-lib';
import { switchMap } from 'rxjs/operators';
import { selectPermWizard } from '../../../../../../../modules/permission/permission-wizard-controller/selectors/permission-wizard.selectors';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-permission-defs',
    templateUrl: './permission-defs.component.html',
    styleUrls: ['./permission-defs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ComponentStore]
  })
export class PermissionDefsComponent implements OnInit, OnDestroy{
  @Input() localState;
  @Output() permLine = new EventEmitter();

  pagination = new Pagination();
  SQLGuids: string[] = null;
  appletGuid = sessionStorage.getItem('appletGuid');
  // initialise ag grid state
  gridApi;
  defaultColDef = {
    filter: 'agTextColumnFilter',
    sortable: true,
    minWidth: 200,
    flex: 2,
    resizable: true,
    suppressCsvExport: true,
    wrapText: true,
    autoHeight: true,
  };
  columnsDefs  = [];
  // api visa
  apiVisa = AppConfig.apiVisa;

  private subs = new SubSink();

  //translation variable
  code_text: string;
  name_text: string;
  type_text: string;
  target_type_text: string;
  default_target_table_text: string;

  constructor(
    private readonly store: Store,
    private permissionTemplateService: PermissionTemplateService,
    private appLoginPrincipalService: AppLoginPrincipalService,
    private injector: Injector
  ) {
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.code_text = res.code;
        this.name_text = res.name;
        this.type_text = res.type;
        this.target_type_text = res.target_type;
        this.default_target_table_text = res.default_target_table;
      });
    } else {
      // Fallback if translation service is unavailable
      this.code_text = 'Code';
      this.name_text = 'Name';
      this.type_text = 'Type';
      this.target_type_text = 'Target Type';
      this.default_target_table_text = 'Default Target Table';
    }
  }

  ngOnInit() {
    this.columnsDefs  = [
      {
        headerName: this.code_text,
       field: 'code',
      // valueGetter: (params) => {
      //     return params.data.app_perm_template_lines[0].code
      // },
        cellStyle: {textAlign: 'left'},
      },
      {
        headerName: this.name_text,
        field: 'name',
        cellStyle: {textAlign: 'left'},
      },
      {
        headerName: this.type_text,
        field: 'type',
        cellStyle: {textAlign: 'left'},
      },
      {
        headerName: this.target_type_text,
        field: 'target_type',
        cellStyle: {textAlign: 'left'},
      },
      {
        headerName: this.default_target_table_text,
        field: 'target_options_json.default_target_hdr_table',
        cellStyle: {textAlign: 'left'},
      }
    ];
  }

  onNext() {
    this.permLine.emit();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
    this.setGridData();
  }

  setGridData(){
    const datasource = {
      getRows: (grid) => {
        const filter = pageFiltering(grid.request.filterModel);
        const sortOn = pageSorting(grid.request.sortModel);

      this.subs.sink = this.store.select(selectPermWizard).pipe(
        switchMap((perm) => {
            console.log('Perm',perm)
            // this.pagination.offset = this.SQLGuids ? 0 : grid.request.startRow;
            // this.pagination.limit = grid.request.endRow - grid.request.startRow;
            this.pagination.conditionalCriteria = [
                { columnName: "calcTotalRecords", operator: '=', value: 'true' },
                { columnName: 'guid', operator: '=', value: perm.app_perm_template_hdr.guid.toString() }
            ];
            console.log(this.pagination)
            return this.permissionTemplateService.getByCriteria(this.pagination, this.apiVisa)
        })
    ).subscribe(
      (resolved) => {
        console.log('resolved', resolved)
        // const data = sortOn(resolved.data[0]?.app_perm_template_lines).filter((entity) => filter.by(entity));
        const data = resolved.data[0]?.app_perm_template_lines.slice(grid.request.startRow, grid.request.endRow);
        // const totalRecords = filter.isFiltering ? (this.SQLGuids ? this.SQLGuids.length : resolved.totalRecords) : resolved.data[0]?.app_perm_template_lines.length;
        const totalRecords = resolved.data[0]?.app_perm_template_lines.length;
        // const totalRecords = resolved.data[0]
        grid.success({
          rowData: data,
          rowCount: totalRecords,
        })
      }
    )
  }
}
this.gridApi.setServerSideDatasource(datasource);
  }

  deletePerms() {
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
